<ng-container *transloco="let t; read: 'configurations.list'">
  <app-lex-xi-side-panel
    [selectedItem]="selectedConfig"
    [rightPlaceholder]="configsRightPlaceholder"
    [isLoading]="isListLoading"
    [verticalTabBarData]="[
      {
        id: 'filter_filled',
        icon: 'filter_filled',
        hasSeparator: true,
        leftSideTemplate: leftSide,
        rightSideTemplate: rightSide,
      },
    ]"
  ></app-lex-xi-side-panel>

  <ng-template #leftSide>
    <div side="left" class="configuration-list__list-wrapper">
      <div class="configuration-list__action-list-container">
        <div class="configuration-list__configuration-list-header">
          <h3 class="configuration-list__configuration-list-label">{{ t('title') }}</h3>
          <div class="configuration-list__header-actions-container">
            @if (configurations?.length && !isListLoading) {
              <div [matTooltip]="sortTooltip">
                <xi-dropdown
                  type="icon"
                  select="single"
                  color="orca"
                  [internalProps]="{ iconButton: { icon: sortIcon } }"
                  [data]="configurationsListSortData"
                  [value]="configurationSort"
                  (onValueChange)="onSortConfigList($event.detail.selected.id)"
                ></xi-dropdown>
              </div>
            }
            <xi-icon-button
              icon="upload"
              [disabled]="isReadOnly"
              [tooltip]="{ text: importConfigurationTooltip() }"
              (onClick)="onImportConfiguration()"
            ></xi-icon-button>

            @if (configurations?.length && !isListLoading) {
              <span [matMenuTriggerFor]="configurationMenuTrigger">
                <xi-fab icon="fab_plus" color="orca" buttonSize="normal"></xi-fab>
              </span>
            }
          </div>
        </div>

        @if (configurations?.length && !isListLoading) {
          <div>
            <ng-container>
              <xi-list
                select="single"
                size="large"
                [hasSearch]="true"
                [hasDragging]="false"
                [hasBorder]="false"
                [internalProps]="internalProps"
                [value]="selectedConfig"
              >
                <div slot="children">
                  <div class="configuration-list__list-sort-dropdown">
                    <xi-dropdown
                      select="single"
                      [value]="configFilter"
                      [data]="configFilterDropdownData"
                      (onValueChange)="
                        configFilter = $event.detail.selected.id; filterConfigurations()
                      "
                    ></xi-dropdown>
                  </div>
                  <div class="configuration-list__scroll">
                    @for (config of filteredConfigurations; track config) {
                      <div class="configuration-list__list-item-container">
                        <xi-list-item
                          [checked]="selectedConfig === config"
                          [attr.id]="config.id"
                          [value]="config.id"
                          (onItemClick)="onConfigSelected(config, $event)"
                          [class.kxi-text-600]="selectedConfig === config"
                        >
                          <div slot="children" class="configuration-list__list-item-left">
                            <div>
                              <div
                                class="kxi-text-normal configuration-list__list-item-name"
                                matTooltip="{{ config.name }}"
                                [matTooltipDisabled]="!(config.name.length >= 30)"
                              >
                                {{ config.name | truncate: 30 }}
                              </div>
                              <p class="kxi-text-xsmall">
                                {{ config.language_name }} |
                                {{ config.removed ? t('deleted') : t('modified') }}:
                                {{ config.modification_date | lexDate: 'short' }}
                              </p>
                              @if (getCreator(config) !== '') {
                                <p class="kxi-text-xsmall">
                                  {{
                                    t('created-by', {
                                      creator: (getCreator(config) | truncate: 30),
                                    })
                                  }}
                                </p>
                              }
                            </div>
                          </div>
                        </xi-list-item>
                        <div
                          class="configuration-list__list-item-right"
                          [class.configuration-list__list-item-right--selected]="
                            selectedConfig === config
                          "
                        >
                          <div class="configuration-list__list-item-tooltip-wrapper">
                            @if (showConfigListItemTooltip(config)) {
                              <div>
                                <xi-tool-tip-content
                                  [tooltip]="{ text: getConfigListItemTooltip(config) }"
                                ></xi-tool-tip-content>
                              </div>
                            }
                          </div>
                          @if (!isInDrawer && !config.removed) {
                            <span
                              #configListActionsMenu="matMenuTrigger"
                              [matMenuTriggerFor]="configurationListActionsTrigger"
                              [matMenuTriggerData]="{ config: config }"
                              (click)="$event.stopPropagation()"
                            >
                              <xi-icon-button icon="kabob"></xi-icon-button
                            ></span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </xi-list>
            </ng-container>
          </div>
        }
        @if (!configurations?.length && !isListLoading) {
          <app-empty-side-panel
            emptyViewText="{{ t('empty-text') }}"
            emptyViewTitle="{{ t('empty-title') }}"
            ctaButtonText="{{ t('empty-cta-btn-text') }}"
            (ctaButtonClick)="openMenuTrigger()"
          ></app-empty-side-panel>
          <span
            class="fake-trigger"
            #configurationMenu="matMenuTrigger"
            [matMenuTriggerFor]="configurationMenuTrigger"
          ></span>
        }
      </div>
    </div>
  </ng-template>

  <!-- RIGHT SIDE -->
  <ng-template #rightSide>
    <div side="right">
      <router-outlet></router-outlet>
    </div>
  </ng-template>

  @if (showCreateConfiguration) {
    <app-create-configuration-drawer
      [groupId]="createConfigData.groupId"
      [existingConfigs]="createConfigData.existingConfigs"
      [nameValidator]="createConfigData.nameValidator"
      [configDto]="createConfigData.sourceConfigDto"
      [configType]="createConfigData.configType"
      [inputFile]="createConfigData.inputFile"
      [fragment]="createConfigData.fragment"
      [open]="showCreateConfiguration"
      (close)="onCloseCreateConfiguration($event)"
    ></app-create-configuration-drawer>
  }

  <mat-menu class="menu-with-xi-icons" #configurationListActionsTrigger>
    <ng-template matMenuContent let-config="config">
      <div [matTooltip]="downloadConfigurationTooltip(config)" [matTooltipPosition]="'left'">
        <button mat-menu-item (click)="onDownloadConfiguration(config)" [disabled]="config.removed">
          <xi-icon icon="download"></xi-icon>
          <div>{{ t('backup') }}</div>
        </button>
      </div>
      <div [matTooltip]="cloneConfigurationTooltip(config)" [matTooltipPosition]="'left'">
        <button
          mat-menu-item
          (click)="onCloneConfiguration(config)"
          [disabled]="!canCloneConfiguration(config) || !!config.removed"
        >
          <xi-icon icon="copy"></xi-icon>
          <div>{{ t('clone') }}</div>
        </button>
      </div>

      @if (isAccountAdmin) {
        <div [matTooltip]="moveConfigurationTooltip(config)" [matTooltipPosition]="'left'">
          <button
            mat-menu-item
            (click)="onMoveConfiguration(config)"
            [disabled]="!canMoveConfiguration(config)"
          >
            <xi-icon icon="exchange"></xi-icon>
            <div>{{ t('move') }}</div>
          </button>
        </div>
      }
    </ng-template>
  </mat-menu>

  <mat-menu #configurationMenuTrigger class="menu-with-xi-icons">
    <button mat-menu-item disabled>{{ t('create') }}</button>

    <div [matTooltip]="isReadOnly ? t('readonly-create') : undefined" matTooltipPosition="left">
      <button
        mat-menu-item
        [disabled]="isReadOnly"
        (click)="onCreateConfiguration('standard')"
        class="configuration-list__create-config-button"
      >
        {{ t('standard-configuration') }}
      </button>
    </div>

    <div [matTooltip]="isReadOnly ? t('readonly-create') : undefined" matTooltipPosition="left">
      <button
        mat-menu-item
        [disabled]="isReadOnly"
        (click)="onCreateConfiguration('layered')"
        class="configuration-list__create-config-button"
      >
        {{ t('layered-configuration') }}
      </button>
    </div>
  </mat-menu>

  <!--Modals -->

  @if (showImportConfigDialog) {
    <app-import-dialog
      [isShowing]="showImportConfigDialog"
      [title]="t('import-configuration-title')"
      [description]="t('import-configuration-content')"
      [itemValidator]="uploadValidator"
      (modalClosed)="onCloseImportConfigurationDialog($event)"
    >
    </app-import-dialog>
  }
  @if (showMoveConfigurationModal) {
    <app-lex-xi-modal
      [isVisible]="showMoveConfigurationModal"
      (close)="afterConfigurationMoved(null)"
      maxWidth="512px"
    >
      <ng-template appXIModalContent>
        @if (showMoveConfigurationModal) {
          <app-move-configuration-dialog
            [config]="moveConfig"
            (modalClosed)="afterConfigurationMoved($event)"
          ></app-move-configuration-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showCloneConfigurationDialog) {
    <app-lex-xi-modal
      maxWidth="512px"
      [isVisible]="showCloneConfigurationDialog"
      (close)="onCloseCloneConfigurationDialog(null)"
    >
      <ng-template appXIModalContent>
        @if (showCloneConfigurationDialog) {
          <app-clone-configuration-dialog
            [data]="cloneConfigData"
            (modalClosed)="onCloseCloneConfigurationDialog($event)"
          ></app-clone-configuration-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
